import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MenuCategory } from '../../../menu/menu-category.model';
import { MenuHoverEvent } from '../menu-hover-event.model';
import { PageGuideService } from '../../../../page-guide/page-guide.service';

@Component({
  selector: 'app-menu-button',
  templateUrl: './menu-button.component.html',
  styleUrls: ['./menu-button.component.css']
})
export class MenuButtonComponent implements OnInit {

  userIsHovering: boolean;
  @Input() category: MenuCategory;
  @Input() menuIndex: number;
  @Input() show: MenuHoverEvent;
  @Input() searchBarIsFocused: boolean;
  @Input() isFullMenuGuied: boolean;
  @Output() isHovered: EventEmitter<MenuHoverEvent> = new EventEmitter<MenuHoverEvent>();
  @Input() initialIndex: number;

  constructor(private router: Router, private pageGuideService: PageGuideService, ) {}

  ngOnInit() {
    this.userIsHovering = false;
    this.searchBarIsFocused = false;
  }

  showMenuOptions() {
    
    this.userIsHovering = true;
    this.isHovered.emit(new MenuHoverEvent(this.userIsHovering, false, this.searchBarIsFocused, this.menuIndex));
  }

  hideMenuOptions() {
    this.userIsHovering = false;
    this.isHovered.emit(new MenuHoverEvent(this.userIsHovering, false, this.searchBarIsFocused, this.menuIndex));
  }


  clickMenuOption() {
    if (this.userIsHovering){
      this.hideMenuOptions();
    }
    else {
      this.showMenuOptions();
    }
  }
  
  chooseMenuOption() {

    if (!this.category) {
      return;
    }  
    this.searchBarIsFocused = false;
    this.showMenuOptions(); 

  }

  get name(): string {

    if (!this.category)
      return '';

    return this.category.name;
  }

  get translationKey(): string {

    if (!this.category)
      return '';

    return this.category.translationKey;
  }

  get hasOptions() {
    
    if (!this.category)
      return false;
    if (!this.category.subMenus)
      return false;

    return this.category.subMenus.length > 0;
  }

  get hoverConditions() {
    
    if (this.searchBarIsFocused)
      return false;

    if (this.pageGuideService.isPageGuideActive && !this.isFullMenuGuied)
      return false;
    else if (this.pageGuideService.isPageGuideActive && this.isFullMenuGuied)
      return true;

    return (this.show && (this.show.panelIsHovered || this.show.buttonIsHovered) && this.show.index === this.menuIndex);
  }

}
